import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { 
    setOrderProperty, 
    setPOType,
    setPOApprovedChecked,
    setSelectAllTodayPOChecked,
    setSelectIncompleteWeighingPOChecked,
    setSelectTodays,
    setPOSupplierType, 
    setPODataApproved,
    setPOSupplier,
    setPORestuarant,
    setPOFilterFields,
    setPOSearchFields,
    setPOApprovedPagination
} from '../js/actions/index';

import { Container, 
    Col, 
    Row, 
    Tabs, 
    Tab, 
    Form, 
    Button, 
    Table, 
    Dropdown, 
    DropdownButton, 
    Alert, 
    ButtonGroup, 
    InputGroup, 
    ToggleButton, 
    OverlayTrigger, 
    Tooltip,
    Spinner } from "react-bootstrap";

import NavbarComponent from '../components/NavbarComponent';
import PaginationComponent from '../components/PaginationComponent';
import LoadingComponent from '../components/LoadingComponent';
import AuthErrorComponent from '../components/AuthErrorComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';
import FooterComponent from '../components/FooterComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import PurchaseOrderERPComponent from '../components/PurchaseOrderERPComponent';
import SearchListComponent from '../components/Form/SearchListComponent';

import { Calendar4, 
    Search, 
    Basket, 
    Shop, 
    PersonBoundingBox, 
    ExclamationCircle, 
    CardList, 
    Cart2, 
    Check2, 
    BoxSeam, 
    ExclamationLg, 
    Truck, 
    HddNetwork,
    ToggleOn, 
    ToggleOff,
    Square,
    CheckSquare,
    Person
 } from 'react-bootstrap-icons';

import moment from 'moment';
import 'moment-timezone';
import "react-dates/initialize"; 
import { SingleDatePicker } from "react-dates"; 
import "react-dates/lib/css/_datepicker.css";

import {NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN} from '../constants/ApiResult';
import { RESTAURANT, SUPPLIER, INTERNAL, EXTERNAL, MULTIABLE, UI, BRANCHES, DEPARTMENTS, SUPPLIERS } from '../constants/GlobalConstant';

import I18N from "../js/i18n";
import {i18n, getCookie} from "../js/global";

const axios = require('axios').default;

const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';
const CREATE = "create";
let timer = null; // debounce alternative

function mapDispatchToProps(dispatch) {
    return {
        setOrderProperty: auth => dispatch(setOrderProperty(auth)),
        setPOType: type => dispatch(setPOType(type)),
        setPOApprovedChecked: type => dispatch(setPOApprovedChecked(type)),
        setSelectAllTodayPOChecked: type => dispatch(setSelectAllTodayPOChecked(type)),
        setSelectIncompleteWeighingPOChecked: type => dispatch(setSelectIncompleteWeighingPOChecked(type)),
        setSelectTodays: type => dispatch(setSelectTodays(type)),
        setPOSupplierType: type => dispatch(setPOSupplierType(type)),
        setPODataApproved: type => dispatch(setPODataApproved(type)),
        setPOSupplier: type => dispatch(setPOSupplier(type)),
        setPORestuarant: type => dispatch(setPORestuarant(type)),
        setPOFilterFields: type => dispatch(setPOFilterFields(type)),
        setPOSearchFields: type => dispatch(setPOSearchFields(type)),
        setPOApprovedPagination: type => dispatch(setPOApprovedPagination(type))
    };
}

class PurchaseOrderRestaurant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            focused:false,
            singleDate: moment(),
            interval: 0,
            isLoading:false,
            startDate: moment().subtract(2, "month"),
            endDate: moment(),
            startDateFormatted: moment().subtract(2, "month").format("YYYY-MM-DD HH:mm:ss"),
            endDateFormatted: moment().format("YYYY-MM-DD HH:mm:ss"),
            dataPO:'',
            dataPOFiltered:[],
            branchIdSearch:'',
            paginationActive: 1,
            paginationSize: 20, // change
            authError:false,
            serverError:false,
            defaultActiveKey:1,
            selectAllToday:false,
            alertErrorMessage:'',
            isVisibleModalERP:false,
            searchPO:'',
            isInternalSupplier:false,
            searchDateType:CREATE,
            searchDate: moment(),
            filterOperator:'',
            poErpIsPush:null,
            key:1,
            dataPODates:[],
            isPOSearch:false,
            poFilterFieldsRefresh:false,
            i18n:{},
            deliveryLineId:0
        }
    }

    componentDidMount = async () => {
        console.log('component did mount');

        // i18n
        let promises = await this.seti18n();

        Promise.all(promises).then(() => {
            this.initData();
        });

        //const confirmI18N = await i18n(UI,'CONFIRM_DATEPICKER_DATE','Do you want to set the datepicker date to today?');

        if(this.isPOFilterFieldsRefresh()) {
            // reset po filter fields
            this.poFilterRefresh()
        }
        
        // set supplier type
        if(this.props.poSupplierType === INTERNAL && this.props.auth.mode === SUPPLIER) {
            this.props.setPOSupplierType(EXTERNAL);
        }
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        this.unlisten();
    }

/*
COOKIE DATEPICKER DATE
*/

    isCookieReactAppDate = () => {
        let date = getCookie('REACT_APP_DATE') ? getCookie('REACT_APP_DATE') : this.props.poSearchFields.searchDate;
        if(!moment(date).isSame(moment(), 'day')) {
            const confirm = window.confirm(this.state.i18n["CONFIRM_DATEPICKER_DATE"]);
            if(confirm) {
                // update po search field searchDate
                this.props.setPOSearchFields({
                    "field":"searchDate",
                    "value":moment().format('YYYY-MM-DD')
                }).then( () => {
                    this.props.setPOApprovedChecked('reset')
                    .then( () => {
                        this.props.setSelectTodays("uncheck");
                        this.setCookieReactAppDate();
                    });
                });
            } else {
                // user didn't want to set datepicker to today.. only ask once
                this.setCookieReactAppDate();
            }
        } else {
            this.setCookieReactAppDate();
        }     
     }

     setCookieReactAppDate = () => {
        document.cookie = `REACT_APP_DATE=${moment()};path=/`;
        this.getPOHistoryList();
     }

/*
Init Data
*/

    initData = () => {
        if(!this.state.dataPO) {
            let mode = this.getMode(this.props.history.location);
            if(!this.props.poType && !this.props.auth.poApproval) {
                mode = 2;
            }

            this.handleInitData(mode);
        }

        this.unlisten = this.props.history.listen((location, action) => {
            let mode = this.getMode(location);

            this.setState({
                isLoading:true
            }, () => {
                this.handleInitData(mode);
            });
        });
    }

    handleInitData = (mode) => {
        this.props.setPOType(mode)
        .then( () => {
            if(mode === 2) {
                this.isCookieReactAppDate();
            } else {
                this.getPOHistoryList();
            }
        });
    }

/*
Get Mode (props.activeKey seems buggy)
*/

    getMode = (location) => {
        let mode = 2;
        if(location.pathname.indexOf('pending') > -1) {
            mode = 1;
        } else if(location.pathname.indexOf('approved') > -1) {
            mode = 2;
        } else if(location.pathname.indexOf('rejected') > -1) {
            mode = 4;
        }
        return mode;      
    }

/*
Po Filter Refresh
*/

    isPOFilterFieldsRefresh = () => {
       if(this.state.poFilterFieldsRefresh) {
           return true;
       }
       return false;
    }

    poFilterRefresh = () => {
        this.props.setPOFilterFields([]).then( () => {
            this.props.setPORestuarant(0).then( () => {
                // reset po supplier type
                if(this.props.auth.mode === SUPPLIER) {
                    this.props.setPOSupplierType(EXTERNAL);
                }
                
                // approved
                if(parseInt(this.props.poType) === 2) {
                    this.props.setPOSupplier({supplierId:"all", supplierName:"All Internal Suppliers"});
                }
            });
        });
    }

/*
API
*/

// Error Handling

    handleServerErrorAPI = (err) => {
        if(err) {
            console.error(err);
        }
        this.setState({
            serverError:true,
            isLoading:false
        });
    }

// PO State

    getPOState = () => {
        let poType = parseInt(this.props.poType);
        let state = [];
        
        if(!poType || poType === 1) {
            state = [1];
        } else if(poType === 2) {
            state = [2,8]
        } else if(poType === 4) {
            state = [4]
        }
        return state;
    }

// (GET) PO History List

    getPOHistoryList = () => {
   
        let specialStartTime;
        let specialEndTime;
        //if(state === 1) {
            specialStartTime = "1900-01-01 00:00:00";
            specialEndTime = "9999-01-01 00:00:00";
        //} else {
        //    specialStartTime = this.state.startDateFormatted;
        //    specialEndTime = this.state.endDateFormatted;
        //}

        let state = this.getPOState();

        /*
            page: 0,
            size: 10
        */

        axios.get(`${process.env.REACT_APP_API_URL}/api/getPOHistoryList/restuarant`, 
        {
            params:{
                businessID:this.props.auth.businessId,
                supplierID:this.props.auth.supplierId,
                specialStartTime:specialStartTime,
                specialEndTime:specialEndTime,
                state: JSON.stringify(state),
                page:0,
                size:800, // CHANGE
                searchDateType:parseInt(this.props.poType) === 2 ? this.props.poSearchFields.searchDateType : "", // CHANGE
                searchDate:moment(this.props.poSearchFields.searchDate).format('YYYY-MM-DD')
            },
            headers: {
              'Authorization': `Basic ${this.props.auth.token}`,
            }
        })
        .then( (response) => {
            let res = response.data;

            if([NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(res.result) > -1) {
                this.setState({
                    authError:true
                });
            } else {
                // sort by createDate desc
                if(this.props.poType > 1) {
                    res.data.sort(function(a,b){
                        return moment(b.CreateDate) - moment(a.CreateDate);
                    });

                    // is this restaurant central kitchen?
                    let isInternalSupplier = false;
                    if(this.props.auth.mode === RESTAURANT) {
                        isInternalSupplier = this.isInternalSupplier(res.data);
                    }

                    let dataPODates = null;
                    if(parseInt(this.props.poType) === 4) {
                        dataPODates = [];
                    }
                    this.setState({
                        dataPO:res.data,
                        dataPOFiltered:res.data,
                        defaultActiveKey:state,
                        isInternalSupplier:isInternalSupplier,
                        key:this.state.key + 1,
                        poErpIsPush:!res.data.length ? [] : null,
                        dataPODates:dataPODates
                    }, () => {
                        // Approved
                        if(parseInt(this.props.poType) === 2) {

                            if(this.isPOFilterFieldsRefresh()) {
                                if(!this.state.isInternalSupplier) {
                                    this.props.setPOSupplierType(EXTERNAL);
                                    this.props.setPOSupplier({supplierId:"all", supplierName:"All External Suppliers"});
                                } else {
                                    this.props.setPOSupplierType(INTERNAL);
                                    this.props.setPOSupplier({supplierId:"all", supplierName:"All Internal Suppliers"});
                                }
                            }
                            
                            ( async () =>  {
                                try {
                                    let poDates = await this.getPODates();
                                    this.setState({
                                        isLoading:false,
                                        dataPODates:poDates.data.data
                                    });
                                } catch (err) {
                                    this.handleServerErrorAPI(err);
                                };
                            })();
                        } else {
                            this.setState({
                                isLoading:false
                            });
                        }
                    });
                } else {

                    // Consolidation === 1

                    // sort by storageDate asc
                    if(this.props.auth.consolidation) {
                        res.data.sort(function(a,b){
                            return moment(a.StorageDate) - moment(b.StorageDate);
                        });                    
                    }

                    let dataUI = [];

                    res.data.forEach( po => {
                        let index;
                        if(this.props.auth.consolidation === true) {
                            // filter to be unique per branchId, storageDate (deliveryDate) and supplierId
                            index = dataUI.findIndex( item => item.BranchId === po.BranchId && item.supplierId === po.supplierId && po.StorageDate === item.StorageDate );
                        } else {
                            index = dataUI.findIndex( item => item.BranchId === po.BranchId && item.supplierId === po.supplierId && item.DepName === po.DepName && item.POId === po.POId );
                        }
                        if(index === -1) {
                            if(po.supplierId) {
                                dataUI.push({
                                    "POId": po.POId,
                                    "SupplierName": po.SupplierName,
                                    "supplierId": po.supplierId,
                                    "CreateDate": po.CreateDate,
                                    "BranchId": po.BranchId,
                                    "BranchName": po.BranchName,
                                    "BranchCode": po.BranchCode,
                                    "DepId": po.DepId,
                                    "DepName": po.DepName,
                                    "OrderName": po.OrderName,
                                    "StorageId": po.StorageId,
                                    "StorageDate": po.StorageDate
                                });
                            }
                        }
                    });

                    this.setState({
                        dataPO:dataUI,
                        dataPOFiltered:dataUI,
                        defaultActiveKey:state,
                        isLoading:false,
                        poErpIsPush:!res.data.length ? [] : null
                    }, () => {
                    });
                }
            }
        })
        .catch( (err) => {
            this.handleServerErrorAPI(err);
        });        
    }

// (GET) PO Dates
    getPODates = () => {
        return axios.get(`${process.env.REACT_APP_API_URL}/api/getPurchaseOrderDates`, 
        {
            params:{
                businessID:this.props.auth.businessId,
                supplierID:this.props.auth.supplierId,
                state:JSON.stringify(this.getPOState())
            },
            headers: {
              'Authorization': `Basic ${this.props.auth.token}`,
            }
        });
    }

// (Boolean) Internal Supplier    
    isInternalSupplier = (array) => {
       if(array.filter( (obj) => obj.supplierBusinessId).length) {
           return true;
       }
       return false;
    }

    handleDateChange = (startDate, endDate) => {
        this.setState(() => ({
          endDate,
          startDate,
        }));
        if (startDate != null) {
          this.setState(() => ({
            startDateFormatted: startDate.format("YYYY-MM-DD HH:mm:ss"),
          }));
        }
        if (endDate != null) {
          this.setState(() => ({
            endDateFormatted: endDate.format("YYYY-MM-DD HH:mm:ss"),
          }));
        }
    }

    handlePOClick = (poId) => {
        this.props.history.push('/purchase-order/'+poId);
    }

    handleClickOrderDate = () => {
        this.getPOHistoryList();
    }

    /*
    handleClickAdvancedSearchClear = () => {
        this.setState({
            branchIdSearch:""
        });
    }*/

    getDataPOFiltered = () => {

        let filter = JSON.parse(JSON.stringify(this.state.dataPO));
        if(this.props.poRestuarant || Number.isInteger(this.props.poSupplier.supplierId)) {
            filter = filter.filter( (po) => {
                if(parseInt(this.props.poType) !== 2 && this.props.poRestuarant) {
                    return parseInt(po.BranchId) === parseInt(this.props.poRestuarant);
                } else {
                    if(this.props.poRestuarant && this.props.poSupplier && !Number.isInteger(this.props.poSupplier.supplierId)) {
                        if(this.props.poSupplierType === EXTERNAL) {
                            return parseInt(po.BranchId) === parseInt(this.props.poRestuarant) && parseInt(po.supplierBusinessId) === 0;   
                        } else {
                            return parseInt(po.BranchId) === parseInt(this.props.poRestuarant) && parseInt(po.supplierBusinessId) !== 0;
                        }
                    } else if(this.props.poSupplier && !Number.isInteger(this.props.poSupplier.supplierId)) {
                        if(this.props.poSupplierType === EXTERNAL) {
                            return parseInt(po.supplierBusinessId) === 0;   
                        } else {
                            return parseInt(po.supplierBusinessId) !== 0;
                        }
                    } else if(this.props.poRestuarant && this.props.poSupplier && Number.isInteger(this.props.poSupplier.supplierId)) {
                        return parseInt(po.BranchId) === parseInt(this.props.poRestuarant) && parseInt(po.supplierId) === parseInt(this.props.poSupplier.supplierId);
                    } else if(this.props.poRestuarant) {
                        return parseInt(po.BranchId) === parseInt(this.props.poRestuarant);
                    } else if(this.props.poSupplier && Number.isInteger(this.props.poSupplier.supplierId)) {
                        return parseInt(po.supplierId) === parseInt(this.props.poSupplier.supplierId);
                    } else {
                        return true;
                    }
                }
            });
        }

        // operator
        if(this.getSearchOperator()) {
            filter = filter.filter( (po) => po.Operator === this.getSearchOperator());
        }

        // po filtered weighing
        if(this.props.poFilterFields.weighing) {
            filter = filter.filter( (po) => po.isWeigh && po.UnsetWeightCount > 0);
        }
        
        if(this.state.interval) {
            // 2020-08-14 12:40:42
            // "Asia/Hong_Kong"
            let timestamp = this.getIntervalTimestamp();

            return filter.filter( (po) => {
                return moment.utc(po.CreateDate).isBetween(moment.utc(timestamp.start), moment.utc(timestamp.end), 'time', '[]');
            });
        } else {
            return filter;
        }
    }

    htmlPOTableRows = (mode, dataPO) => {

        let start = (this.props.poApprovedPagination - 1) * this.state.paginationSize;
        let end = this.props.poApprovedPagination * this.state.paginationSize;

        let html = dataPO.slice(start, end).map( (row, index) => {

            let createDate = row.CreateDate.replace(/T/, ' ').replace(/\..+/, '');
            let storageDate = row.StorageDate.replace(/T/, ' ').replace(/\..+/, '');
   
            let url;
            if(this.props.auth.consolidation === true) {
                url = `/purchase-orders/approval-consolidate/${row.supplierId}/${row.BranchId}/${moment(row.StorageDate).format('YYYY-MM-DD')}`;
            } else {
                url = `/purchase-order/approval/${row.supplierId}/${row.BranchId}/${row.POId}`;
            }

            if(mode === 1) {
                return (
                    <tr key={index}>
                        {!this.props.auth.consolidation &&
                        <td>
                            <Button variant="link" type="button" onClick={() => this.props.history.push(url)}>
                                {row.OrderName}
                            </Button>
                        </td>
                        }    
                        <td>
                            {
                            !this.props.auth.consolidation
                                ?
                                <I18N 
                                    type={BRANCHES} 
                                    value={{
                                        "businessId":this.props.auth.businessId,
                                        "branchId":row.BranchId
                                    }} 
                                    property="BranchName" 
                                    def={row.BranchName}
                                />
                                :
                                <Button variant="link" type="button" onClick={() => this.props.history.push(url)}>
                                    <I18N 
                                    type={BRANCHES} 
                                    value={{
                                        "businessId":this.props.auth.businessId,
                                        "branchId":row.BranchId
                                    }} 
                                    property="BranchName" 
                                    def={row.BranchName}
                                    />
                                </Button>
                            }
                        </td>
                        {this.props.auth.consolidation &&
                        <td>
                            {moment(row.StorageDate).format('DD-MM-YYYY')}
                        </td>
                        }
                        {!this.props.auth.consolidation && 
                        <td>
                            <I18N 
                                type={DEPARTMENTS} 
                                value={{
                                    "businessId":this.props.auth.businessId,
                                    "branchId":row.BranchId,
                                    "depId":row.DepId
                                }} 
                                property="DepName" 
                                def={row.DepName}
                            />
                        </td>
                        }
                        {this.props.auth.mode === RESTAURANT &&
                        <td className="align-middle">
                            <I18N 
                                type={SUPPLIERS} 
                                value={row.supplierId}
                                property="SupplierName"
                                def={row.SupplierName}
                            />
                        </td>
                        }
                    </tr>
                )
            } else {
                return (
                    <tr key={index}>
                        {(mode === 2 && (this.props.poSupplierType === INTERNAL || this.props.auth.mode === SUPPLIER)) &&
                        <td className="align-middle">
                            <Form.Check
                                className="text-center"
                                style={{paddingLeft:'1.75rem'}}
                                type="checkbox" 
                                label=""
                                checked={this.getPOChecked(row.POId, dataPO)}
                                onChange={() => {
                                    this.props.setPOApprovedChecked([row.POId])
                                    .then( () => {

                                        if(this.props.poApprovedChecked.length === this.state.dataPO.length) {
                                            this.props.setSelectTodays("purchases"); 
                                        } else if(!this.props.poApprovedChecked.length) {
                                            this.props.setSelectTodays("uncheck"); 
                                        }

                                        /*
                                        if(this.props.selectTodays === "uncheck") {
                                            this.props.setSelectTodays("");
                                        }
                                        */

                                        /*
                                        if(this.props.poApprovedChecked.length === 0) {
                                            this.props.setSelectAllTodayPOChecked(false);
                                        }
                                        */

                                        /*
                                        if(!this.props.poSupplier) {
                                            // check if they beloing to same supplier
                                            this.isPoApprovedCheckedSameSupplier();
                                        }
                                        */
                                    });
                                }}
                                disabled={this.getPOCheckedDisabled(row.POId)}
                            />
                        </td>
                        }
                        <td>
                        <Button variant="link" type="button" onClick={() => this.handlePOClick(row.POId)}>
                            {row.OrderName}
                            {this.props.auth.erp.platform === MULTIABLE &&
                            <img 
                            src={process.env.PUBLIC_URL+`/assets/images/logo_multiable${this.poErpIsPush(row.OrderName) ? "" : "_error"}.svg`} 
                            alt="m18"
                            className="ms-1 mb-1"
                            style={{width: '16px', height: '16px'}}
                            />
                            }
                        </Button>
                        </td>
                        <td className="align-middle">{`${moment(createDate).format('D MMM YYYY')} ${moment(createDate).format('LT')}`}</td>
                        <td className="align-middle">{moment(storageDate).format('D MMM YYYY')}</td>
                        <td className="align-middle">
                            <I18N 
                                type={BRANCHES} 
                                value={{
                                    "businessId":this.props.auth.businessId,
                                    "branchId":row.BranchId
                                }} 
                                property="BranchName" 
                                def={row.BranchName}
                            />
                        </td>
                        {!this.props.auth.consolidation && 
                        <td className="align-middle">
                            <I18N 
                                type={DEPARTMENTS} 
                                value={{
                                    "businessId":this.props.auth.businessId,
                                    "branchId":row.BranchId,
                                    "depId":row.DepId
                                }} 
                                property="DepName" 
                                def={row.DepName}
                            />
                        </td>
                        }
                        {this.props.auth.mode === RESTAURANT &&
                        <td className="align-middle">
                            <I18N 
                                type={SUPPLIERS} 
                                value={row.supplierId}
                                property="SupplierName"
                                def={row.SupplierName}
                            />
                        </td>
                        }
                        {mode === 2 && this.props.auth.ui.purchaseOrders.approved.weighing &&
                        <td className="align-middle">
                            {row.isWeigh > 0 && 
                            <>
                            {!row.UnsetWeightCount
                            ?
                                <Check2 size={16} className="text-success" />
                            :
                                <ExclamationLg size={16} className="text-danger" />
                            }
                            </>
                            }
                        </td>
                        }
                    </tr>
                )
            }


        });

        return html;
    }

    /*
   isPoApprovedCheckedSameSupplier = () => {
        let supplierId;
        let error = false;
        this.props.poApprovedChecked.forEach( (poId) => {
            let data = this.state.dataPO.filter( (po) => po.POId === poId )[0];
            if(!supplierId) {
                supplierId = data.supplierId;
            } else {
                if(supplierId !== data.supplierId) {
                    error = true;
                    this.setState({
                        alertErrorMessage:'Selected purchase orders must belong to the same supplier to print picking list'
                    });
                }
            }
        });
        if(!error) {
            this.setState({
                alertErrorMessage:''
            });
        }
   }*/

    getPOChecked = (poId, dataPO) => {
        if(this.props.poApprovedChecked.indexOf(poId) > -1 && dataPO.findIndex( (po) => po.POId === poId ) > -1) {
            return true;
        } else {
            return false;
        }
    }

    getPOCheckedDisabled = (poId) => {
        /*
        // Disable for now, too strict UX
        if(this.props.selectTodays === "weighing") {
            let data = this.state.dataPOFiltered.filter( (obj) => obj.POId === poId )[0];
            if(typeof data === "object" && !data.isWeigh) {
                return true;
            }
        }
        */
        return false;
    }

    /*
    htmlPOApprovedTableRows = () => {

        let data = this.state.dataPO;
      
        //if( this.state.supplierSearchTermsSubmit ) {
        //    data = this.getDataPOFiltered();
        //}
      
        let start = (this.state.paginationActive - 1) * this.state.paginationSize;
        let end = this.state.paginationActive * this.state.paginationSize;

        let html = data.slice(start, end).map( (row, index) => {

            let date = row.CreateDate.replace(/T/, ' ').replace(/\..+/, '');

            return (
                <tr key={index}>
                    <td>
                    <Button variant="link" type="button" onClick={() => this.handlePOClick(row.POId)}>
                        {row.OrderName}
                    </Button>
                    </td>
                    <td className="align-middle">{formatUTC(date)}</td>
                    <td className="align-middle">{row.BranchName}</td>
                    <td className="align-middle">{row.SupplierName}</td>
                </tr>
            )
        });
        return html;
    }
    */

    handleClickPaginationItem = (active) => {
        this.props.setPOApprovedPagination(active)
        .then( () => {
            this.setState({
                //paginationActive:active,
                isLoading:this.props.auth.erp.platform === MULTIABLE ? true : false,
                poErpIsPush:null,
                key:this.state.key + 1
            });
        });
    }

    formatUTC(utc) {
        const formattedDate = new Date(utc).toLocaleDateString({},{timeZone:"UTC",month:"short", day:"2-digit", year:"numeric"});
        return formattedDate;
    }

    handleOnSelectAdvancedSearchRestaurant = (value) => {
        this.props.setPORestuarant(value)
        .then( () => {
            this.setState({
                //paginationActive:1,
                alertErrorMessage:''
            }, () => {
                this.props.setPOApprovedPagination(1)
                .then( () => {
                    this.setPOApprovedChecked();
                    this.getErpIsPush();
                });
                //this.setPOApprovedRadio();
            });
        });
    }

    getAdvancedSearchRestaurantTitle = () => {
        if(this.props.poRestuarant) {
            let dataPO = JSON.parse(JSON.stringify(this.state.dataPO));
            let obj = dataPO.filter( po => parseInt(po.BranchId) === parseInt(this.props.poRestuarant))[0];
            if(obj) {
                return <I18N 
                type={BRANCHES} 
                value={{
                    "businessId":this.props.auth.businessId,
                    "branchId":obj.BranchId
                }} 
                property="BranchName" 
                def={obj.BranchName}
                />
            }
            return <I18N type={UI} path="ALL_BRANCHES" def="All Branches"/>;
        } else {
            return <I18N type={UI} path="ALL_BRANCHES" def="All Branches"/>;
        }
    }

    htmlAdvancedSearchRestaurantOptions = () => {
        let arry = [];
        let html = this.state.dataPO.map( (row, index) => {
            if(arry.indexOf(row.BranchId) === -1) {
                arry.push(row.BranchId);
                return (
                    <Dropdown.Item as="button" key={index} eventKey={row.BranchId}>
                        <I18N 
                            type={BRANCHES} 
                            value={{
                                "businessId":this.props.auth.businessId,
                                "branchId":row.BranchId
                            }} 
                            property="BranchName" 
                            def={row.BranchName}
                        />
                    </Dropdown.Item>
                );
            } else return "";
        });
        return html;
    }

// Branch

    getBranchData = () => {
        let array = [];
        this.state.dataPO.forEach( (obj, index) => {
            if(array.findIndex( (branch) => branch.id === obj.BranchId ) === -1) {
                array.push({
                    id:obj.BranchId,
                    label:`(${obj.BranchCode}) ${obj.BranchName}`,
                    deliveryLine:obj.DeliveryLine,
                    searchText:`${obj.BranchName}${obj.BranchCode}`
                })
            }
        });

        // is delivery line selected?
        if(this.props.poFilterFields['deliveryLine']) {
            array.filter( (obj) => obj.deliveryLine === this.props.poFilterFields['deliveryLine']);
        }

        return array;
    }

// Delivery Lines

    getDeliveryLinePOCount = (deliveryLine) => {
        let count = 0;
        this.state.dataPO.forEach( (obj) => {
            let data = JSON.parse(obj.deliveryLine);
            if(typeof data.id !== "undefined" && data.id === deliveryLine) {
                count++;
            }
        });
        return count;
    }

    getDeliveryLineData = () => {
        let array = [];
        this.state.dataPO.forEach( (obj, index) => {
            let data = JSON.parse(obj.deliveryLine);
            if (data){    
                if(typeof data.id !== "undefined" && array.findIndex( (deliveryLine) => deliveryLine.id === data.id ) === -1) {
                    array.push({
                        id:data.id,
                        label:data.label
                    });
                }
            }
        });
        return array;  
    }

    deliveryLineTitle = () => {
        if(this.props.poFilterFields['deliveryLine']) {
            const data = this.getDeliveryLineData();
            const filter = data.filter( (obj) => obj.id === this.props.poFilterFields['deliveryLine'] )[0];
            if(filter) {
                return filter.label;
            }
            return "Select Delivery Line";
        } else {
            return "Select Delivery Line";
        }
    }

    deliveryLineOptions = () => {
        let data = this.getDeliveryLineData();
        return data.map( (obj) => {
            return <Dropdown.Item as="button" key={obj.id} eventKey={obj.id}>{obj.label} ({this.getDeliveryLinePOCount(obj.id)})</Dropdown.Item>
        })
    }

    handleOnSelectDropdownFilterDeliveryLine = (id) => {
        this.props.setPOFilterFields([{
            field:'deliveryLine',
            value:parseInt(id)
        }]).then( () => {
            this.props.setPOApprovedPagination(1)
            .then( () => {
                this.getErpIsPush()
            });  
        });
    }

    handleAdvancedSearchSubmit = (e) => {
        e.preventDefault();
    }

    handleSelectTab = (value) => {
        value = parseInt(value);
        let mode = "";
        if(value === 1) {
            mode = "pending-approval";
        } else if( value === 2 ) {
            mode = "approved";
        } else if(value === 4) {
            mode = "rejected";
        }
        
        this.setState({
            isLoading:true,
            poFilterFieldsRefresh:true
        }, () => {
            this.props.setPOType(value)
            .then( () => {
                this.poFilterRefresh();
                this.props.history.push('/purchase-orders/'+mode);
            });
        });
    }

    setPOApprovedChecked = () => {
        // Splice the poId from checked array to preserve
        
        let checked = JSON.parse(JSON.stringify(this.props.poApprovedChecked));
        this.props.poApprovedChecked.forEach( (poId) => {
            let data = this.state.dataPO.filter( (po) => po.POId ===  poId)[0];
            let index = checked.indexOf(poId);

            if(parseInt(this.props.poRestuarant) > 0 === true && parseInt(this.props.poSupplier.supplierId) > 0 === true) {
                if(data.BranchId === this.props.poRestuarant && data.supplierId === this.props.poSupplier.supplierId) {
                    if(index > -1) {
                        checked.splice(index,1);
                    }
                }
            } else if(parseInt(this.props.poRestuarant) > 0 === true && parseInt(this.props.poSupplier.supplierId) > 0 === false) {
                if(data.BranchId === this.props.poRestuarant) {
                    if(index > -1) {
                        checked.splice(index,1);
                    }
                }
            } else if(parseInt(this.props.poRestuarant) > 0 === false && parseInt(this.props.poSupplier.supplierId) > 0 === true) {
                if(data.supplierId === this.props.poSupplier.supplierId) {
                    if(index > -1) {
                        checked.splice(index,1);
                    }
                }        
            } else {
                checked.splice(index,1);
            }
        });

        this.props.setPOApprovedChecked(checked)
        .then( () => {
            //console.log(this.props.poApprovedChecked);
        })
    }

/*
Select Today's
*/


    handleOnChangeSelectTodays = (value) => {
        
        let option = "purchases";
        if(!value) {
            option = "uncheck";
        }

        this.props.setSelectTodays(option)
        .then( () => {
            this.setPOApprovedRadio('onChange');
        });
    }


/*
Select Today's Purchases
*/

    /*
    handleOnChangeSelectAllTodayPO = () => {
        this.props.setSelectAllTodayPOChecked(!this.props.selectAllTodayPO)
        .then( () => {
            this.setPOChecked();
        });
    }
    */

    setPOApprovedRadio = (mode) => {
        let data = this.getSearchPODataFilter(this.getDataPOFiltered());
        let poApprovedChecked = JSON.parse(JSON.stringify(this.props.poApprovedChecked));
        let checked = JSON.parse(JSON.stringify(this.props.poApprovedChecked));
        
        if(mode === "onChange") {
            this.props.setPOApprovedChecked('reset');
            checked = [];
        }

        //let today = moment().format('YYYY-MM-DD');
        
        data.forEach ( (po) => {
            let index = checked.indexOf(po.POId);
            //let createDate = moment(po.CreateDate).utc().format('YYYY-MM-DD');
            if(this.props.selectTodays === "purchases") {
                if(index === -1) {
                    checked.push(po.POId); 
                } else {
                    checked.splice(index, 1);
                }
            } else if(this.props.selectTodays === "weighing") {
                if(po.isWeigh && po.UnsetWeightCount > 0) {
                    if(index === -1) {
                        checked.push(po.POId); 
                    } else {
                        checked.splice(index, 1);
                    }
                }
            } else if(this.props.selectTodays === 'all') {
                if(index === -1) {
                    checked.push(po.POId); 
                } else {
                    checked.splice(index, 1);
                }
            } else if(this.props.selectTodays === 'uncheck') {
                let idx = poApprovedChecked.indexOf(po.POId);
                if(idx > -1) {
                    poApprovedChecked.splice(idx, 1);
                }
            } else {
                // nothing happens
                if(this.props.poApprovedChecked.length) {
                    this.props.setPOApprovedChecked('reset');
                }
            }
        });

        if(this.props.selectTodays === "uncheck") {
            checked = poApprovedChecked;
        }

        let uniqueChecked = [...new Set(checked)];
        if(uniqueChecked.length) {
            this.props.setPOApprovedChecked(uniqueChecked);
        }
    }

/*
Select Weighing Purchases
*/  

    /*

    handleOnChangeSelectIncompleteWeighingPO = () => {
        this.props.setSelectIncompleteWeighingPOChecked(!this.props.selectIncompleteWeighingPO)
        .then( () => {
            this.setPickPackChecked();
        });
    }
    */

    /*
    handleOnChangePOSupplierType = () => {
        let type;
        if(this.props.poSupplierType === INTERNAL) {
            type = "";
        } else {
            type = INTERNAL;
        }
        this.props.setPOSupplierType(type);
    }

    getSupplierTypeChecked = () => {
        return this.props.poSupplierType;
    }
    */

/*
Pick Pack List
*/

    getPickPackDisabled = () => {
        let dataPOFiltered = this.getDataPOFiltered();
        let poApprovedChecked = false;

        if(dataPOFiltered.length) {
            // are these po approved checked visible POs?
            this.getDataPOFiltered().forEach( (po) => {
                if(this.props.poApprovedChecked.indexOf(po.POId) > -1){
                    poApprovedChecked = true;
                }
            });
        }

        if(!poApprovedChecked || this.state.alertErrorMessage) {
            return true;
        }
        return false;
    }

    /*
    getPackDisabled = () => {
        if(this.props.poApprovedChecked.length === 0) {
            return true;
        }
        return false;
    }*/

    handleOnClickPickingList = () => {
        this.props.setPODataApproved(this.getDataPOFiltered())
        .then( () => {
            this.props.history.push('/picking-list');
        });
    }

    handleOnClickPackingList = () => {
        /*
        let po = this.getVisiblePOApprovedChecked();
        if(po) {
            this.props.setPODataApproved(this.getDataPOFiltered())
            .then( () => {
                this.props.history.push('/packing-list/');
            });
        } else {
            this.setState({
                alertErrorMessage:'Select purchase order(s) to proceed'
            });
        }*/

        if(this.props.auth.mode !== "supplier" || !this.props.auth.logisticsTable) {
            this.props.setPODataApproved(this.getDataPOFiltered())
            .then( () => {
                this.props.history.push('/packing-list/');
            });
        } else {
            this.props.history.push('/pick-pack-delivery/');
        }
    }

/*
Weighing List
*/

    getWeighingDisabled = () => {
        // is there is a weighing list PO checked?
        let weighingDisabled = true;
        this.props.poApprovedChecked.forEach( (poId) => {
            let data = this.state.dataPOFiltered.filter( (po) => po.POId === poId )[0];
            if(typeof data === "object" && data.isWeigh) {
                weighingDisabled = false;
            }

        });
        return weighingDisabled;
    }

    handleOnClickWeighingList = () => {
        this.props.setPODataApproved(this.getDataPOFiltered())
        .then( () => {
            this.props.history.push('/weighing-list/');
        });
    }

    /*
    getVisiblePOApprovedChecked = () => {
        let dataPOFiltered = this.getDataPOFiltered();
        let poString;

        if(dataPOFiltered.length) {
            // are these po approved checked visible POs?
            this.getDataPOFiltered().forEach( (po) => {
                if(this.props.poApprovedChecked.indexOf(po.POId) > -1){
                    if(!poString) {
                        poString = po.POId;
                    } else {
                        poString = poString + ',' + po.POId;
                    }
                }
            });
        }
        return poString;
    }
    */

    getAdvancedSearchSupplierTitle = () => {
        if(this.props.poSupplier) {
            return this.props.poSupplier["supplierName"];
        }
        return "Select Supplier";
    }

    handleOnSelectAdvancedSearchSupplier = (supplier) => {
        let value = "";
        if(supplier) {
            value = JSON.parse(supplier);
        }
        this.props.setPOSupplier(value)
        .then( () => {
            this.setState({
                //paginationActive:1,
                alertErrorMessage:''
            }, () => {
                this.props.setPOApprovedPagination(1)
                .then( () => {
                    this.setPOApprovedChecked();
                    this.setPOApprovedRadio();
                });
            });
        });
    }

    htmlAdvancedSearchSupplierOptions = () => {
        let html;
        let resArr = [];
        this.state.dataPO.forEach( (product) => {
        let i = resArr.findIndex(x => x.supplierId === product.supplierId);
            if(i <= -1 && (this.props.poSupplierType === EXTERNAL && product.supplierBusinessId === 0) 
            ||  ((this.props.poSupplierType === INTERNAL || this.props.auth.mode === SUPPLIER) && product.supplierBusinessId !== 0)) {
                resArr.push({supplierId: product.supplierId, supplierName: product.SupplierName});
            }
        });

        if(resArr.length) {
            html = resArr.map( (supplier) => {
                return (
                <Dropdown.Item as="button" eventKey={JSON.stringify({supplierId:supplier.supplierId, supplierName: supplier.supplierName})}>{supplier.supplierName}</Dropdown.Item>
                )
            });          
        }
        return html;
    }

    handleOnSelectAdvancedSearchSupplierType = (value) => {
        this.props.setPOSupplierType(value);
    }

    getAdvancedSearchSupplierTypeTitle = () => {
        if(this.props.poSupplierType) {
           if(this.props.poSupplierType === INTERNAL) {
                return "Internal";
           } else {
                return "External";
           }
        } else {
            return "Select Type";
        }
    }

    getAdvancedSearchSupplierExternalTitle = () => {
        if(this.props.poSupplierType === EXTERNAL && typeof this.props.poSupplier.supplierId !== "undefined") {
            if(!Number.isInteger(this.props.poSupplier.supplierId)) {
                return <I18N type={UI} path="ALL_EXTERNAL_SUPPLIERS" def="All External Suppliers"/>;
            }
            return this.props.poSupplier.supplierName;
        }
        return <I18N type={UI} path="SELECT_EXTERNAL_SUPPLIERS" def="Select External Suppliers"/>;
    }

    handleOnSelectAdvancedSearchExternal = (value) => {
        this.props.setPOSupplierType('external')
        .then( () => {
            if(value) {
                this.props.setPOSupplier(JSON.parse(value));
            } else {
                this.props.setPOSupplier({});
            }
        });
    }

    htmlAdvancedSearchExternalSupplierOptions = () => {
        // external businessId == 0
        let suppliers = [];
        let html = this.state.dataPO.map( (po) => {
            if(po.supplierBusinessId === 0) {
                if(suppliers.indexOf(po.supplierId) === -1) {
                    suppliers.push(po.supplierId);
                    return <Dropdown.Item as="button" eventKey={JSON.stringify({supplierId:po.supplierId, supplierName:po.SupplierName})}>{po.SupplierName}</Dropdown.Item>
                } else return "";
            } else return "";
        })
        return html;
    }

    getAdvancedSearchSupplierInternalTitle = () => {
        if(this.props.poSupplierType === INTERNAL && typeof this.props.poSupplier.supplierId !== "undefined") {
            if(!Number.isInteger(this.props.poSupplier.supplierId)) {
                return <I18N type={UI} path="ALL_INTERNAL_SUPPLIERS" def="All Internal Suppliers"/>;
            }
            return this.props.poSupplier.supplierName;
        }
        return <I18N type={UI} path="SELECT_INTERNAL_SUPPLIERS" def="Select Internal Suppliers"/>;
    }

    handleOnSelectAdvancedSearchInternal = (value) => {
        this.props.setPOSupplierType('internal')
        .then( () => {
            if(value) {
                this.props.setPOSupplier(JSON.parse(value));
            } else {
                this.props.setPOSupplier({});
            }
        });
    }

    htmlAdvancedSearchInternalSupplierOptions = () => {
        // internal businessId != 0
        let suppliers = [];
        let html = this.state.dataPO.map( (po, index) => {
            if(po.supplierBusinessId !== 0) {
                if(suppliers.indexOf(po.supplierId) === -1) {
                    suppliers.push(po.supplierId);
                    return <Dropdown.Item key={index} as="button" eventKey={JSON.stringify({supplierId:po.supplierId, supplierName:po.SupplierName})}>{po.SupplierName}</Dropdown.Item>
                } else return "";
            } else return "";
        })
        return html;
    }

    htmlIntervalOptions = () => {
        return this.props.auth.intervals.map( (interval) => {
            return <Dropdown.Item as="button" eventKey={interval.id}>{interval.label}</Dropdown.Item>
        });
    }

    getIntervalTitle = () => {
        if(!this.state.interval) {
            return "Select Interval";
        } else {
            return this.props.auth.intervals.filter( (obj) => obj.id === parseInt(this.state.interval) )[0].label;
        }
    }

    getIntervalTimestamp = () => {
        let timestamp = {
            start:'',
            end:''
        }
        if(this.state.interval) {
            let filter = this.props.auth.intervals.filter( (obj) => obj.id === parseInt(this.state.interval) )[0];
            if(filter.past) {
                timestamp.start = moment(this.state.singleDate).subtract(1, "days").format('YYYY-MM-DD') + ' ' + filter.start;
                timestamp.end = moment(this.state.singleDate).format('YYYY-MM-DD')+ ' ' + filter.end;
            } else {
                timestamp.start = moment(this.state.singleDate).format('YYYY-MM-DD')+ ' ' + filter.start;
                timestamp.end = moment(this.state.singleDate).format('YYYY-MM-DD')+ ' ' + filter.end;
            }
        }
        return timestamp;
    }

    handleOnSelectInterval = (interval) => {
        this.setState({
            interval:interval
        });
    }

/*
Search PO
*/
    handleSearchPOChange = (value) => {
        this.setState({
            //searchPO:value,
            isPOSearch:this.props.auth.erp.platform === MULTIABLE ? true : false
        }, () => {

            this.props.setPOFilterFields([{
                field:'searchPO',
                value:value
            }]).then( () => {
                this.props.setPOApprovedPagination(1);
            });

            clearTimeout(timer); 
            timer = setTimeout(() => {
                this.getErpIsPush();
            }, 1000);
        });
    }

    getSearchPOString = () => {
        if(this.props.poFilterFields.searchPO) {
            return this.props.poFilterFields.searchPO;
        }
        return "";
    }

    getSearchPODataFilter = (data) => {
        // search string
        if(this.getSearchPOString()) {
            return data.filter( (obj) => obj.OrderName.toLowerCase().indexOf(this.getSearchPOString().toLowerCase()) > -1);
        } else {
            return data;
        }
    }

    getDeliveryLinePODataFilter = (data) => {
        // delivery line
        const deliveryLine = this.props.poFilterFields['deliveryLine'];
        if(deliveryLine) {
            return data.filter( (obj) => {
                const json = JSON.parse(obj.deliveryLine);
                return (typeof json.id != "undefined" && json.id === deliveryLine) 
            });
        }
        return data;
    }

/*
Operator
*/

    getSearchOperator = () => {
        if(this.props.poFilterFields.operator){
            return this.props.poFilterFields.operator;
        }
        return;    
    }

    getSearchOperatorTitle = () => {
        if(this.props.poFilterFields.operator){
            return this.props.poFilterFields.operator;
        }
        return <I18N type={UI} path="ALL_OPERATORS" def="All Operators"/>;
    }

    handleOnSelectOperator = (value) => {
        this.props.setPOApprovedPagination(1)
        .then( () => {
            this.props.setPOFilterFields([{
                field:'operator',
                value:value
            }]).then( () => {
                this.getErpIsPush();
            });
            /*
            this.setState({
                filterOperator:value
            }, () => {
                this.getErpIsPush();
            });
            */
        });
    }

    htmlSearchOperatorOptions = () => {
        let data = [];
        this.state.dataPO.forEach( (po) => {
            if(data.indexOf(po.Operator) === -1 && po.Operator) {
                data.push(po.Operator);
            }
        });

        return data.map( (operator, index) => (
            <Dropdown.Item key={index} as="button" eventKey={operator}>{operator}</Dropdown.Item>
        ));
    }

/*
Filter Weighing
*/

    handleFilterWeighing = (value) => {
        this.props.setPOFilterFields([{
            field:'weighing',
            value:value
        }]);
    }

/*
Search Date
*/

    handleToggleDate = (searchDateType) => {
        this.props.setPOSearchFields({
            "field":"searchDateType",
            "value":searchDateType === 'create' ? 'delivery' : 'create'
        }).then( () => {
            this.getPOHistoryList();
        });
    }

    handleSearchDateChange = (date) => {

        this.props.setPOSearchFields({
            "field":"searchDate",
            "value":moment(date).format('YYYY-MM-DD')
        }).then( () => {
            this.setState({
                isLoading:true,
                //paginationActive:1
            }, () => {
                this.props.setPOApprovedPagination(1)
                .then( () => {
                    this.props.setPOApprovedChecked('reset')
                    .then( () => {
                        this.props.setSelectTodays("uncheck");
                        this.getPOHistoryList();
                    });
                });
            });
        });
    }

/*
PO ERP Pushed
*/

    getPOERPSearchConditions = (data) => {

        // get data based on pagination
        let start = (this.props.poApprovedPagination - 1) * this.state.paginationSize;
        let end = this.props.poApprovedPagination * this.state.paginationSize;

        // 2 - 1 * 20 = 20
        // (2 * 20) - 1 = 39

        // array.slice(start, end); end is index of last item
        let array = data.slice(start, end);
        let cond = "";

        array.forEach( (po) => {
            if(!cond) {
                cond = `udfhorussono=equal=${po.OrderName}`
            } else {
                cond = cond+`=or=udfhorussono=equal=${po.OrderName}`
            }
        });

        return cond;
    }

    poErpIsPush = (orderName) => {
        let index = this.state.poErpIsPush.findIndex( (obj) => obj.udfhorussono === orderName);  
        if(index > -1) {
            return true;
        }
        return false;
    }

    getErpIsPush = () => {
        if(this.props.auth.erp.platform === MULTIABLE) {
            this.setState({
                isLoading:true
            }, () => {
                setTimeout(() => {
                    if(this.getPOData().length) {
                        this.setState({
                            key:this.state.key + 1
                        });                     
                    } else {
                        this.setState({
                            isLoading:false,
                            isPOSearch:false
                        });
                    }
                },250);
            });
        }
    }

    


/*
HTML PO Tab
*/

    getPOData = () => {
        let data = JSON.parse(JSON.stringify(this.getDataPOFiltered()));
       
        // search string
        data = this.getSearchPODataFilter(data);

        // delivery line
        data = this.getDeliveryLinePODataFilter(data);

        return data;
    }

    htmlPOTab = (mode) => {
        
        let paginationLength = 0;
        let paginationIntervals = 0;

        let data = this.getPOData();

        if(data) {
            paginationLength = data.length;
            paginationIntervals = Math.ceil(data.length / this.state.paginationSize);
        }

        let highlightedDays = [];
        if(this.state.dataPODates) {
            highlightedDays = this.state.dataPODates[this.props.poSearchFields.searchDateType];
        }
        
        return (
        <>
        {(mode === 2 && (this.props.poSupplierType === INTERNAL || this.props.auth.mode === SUPPLIER)) &&  
        <Row>
            <Col>
                <div className="text-lg-end mt-2">
                    {this.props.auth.erp.pushDate &&
                    <Button variant="link" type="button" className="me-1" disabled={this.isDisabledButtonERP()} onClick={ () => this.handleOpenModalERP()}>
                        <HddNetwork size={16} className="mb-1 me-1" />
                        <I18N type={UI} path="PUSH_TO_ERP" def="Push to ERP"/>
                    </Button>
                    }
                    {this.props.auth.ui.purchaseOrders.approved.pickingList &&                
                    <Button variant="link" type="button" className="me-1" disabled={this.getPickPackDisabled() ? true : false } onClick={() => this.handleOnClickPickingList()}>
                        <Cart2 size={16} className="mb-1 me-1" />
                        <I18N type={UI} path="PICKING_LIST" def="Picking List"/>
                    </Button>
                    }
                    {this.props.auth.ui.purchaseOrders.approved.weighing &&
                    <Button variant="link" type="button" disabled={this.getWeighingDisabled() ? true : false } onClick={() => this.handleOnClickWeighingList()}>
                        <BoxSeam size={16} className="mb-1 me-1" />
                        <I18N type={UI} path="WEIGHING_LIST" def="Weighing List"/>
                    </Button>
                    }
                    {this.props.auth.ui.purchaseOrders.approved.packingList &&
                    <Button variant="link" type="button" disabled={this.getPickPackDisabled() ? true : false } onClick={() => this.handleOnClickPackingList()}>
                        <Truck size={16} className="mb-1 me-1" />
                        <I18N type={UI} path="PACKING_LIST" def="Packing List"/>
                    </Button>
                    }
                </div>
            </Col>
        </Row>
        }
        <Row className="bg-light rounded-top">
            {this.props.auth.mode === SUPPLIER &&
            <Col className="d-sm-flex ms-3">
                <div className="mt-4 me-4">
                    <Form.Group controlId="dropdownFilterDeliveryLineButton">
                        <Form.Label className="font-weight-bold"><Truck size={16} className="mb-1 me-1" /> Delivery Line</Form.Label>
                        <DropdownButton
                            className="d-grid mw-200"
                            id="dropdownFilterDeliveryLineButton"
                            title={this.deliveryLineTitle()}
                            onSelect={this.handleOnSelectDropdownFilterDeliveryLine}
                        >
                            <Dropdown.Item className="mw-200" as="button" eventKey="">All Delivery Lines</Dropdown.Item>
                            {this.deliveryLineOptions()}
                        </DropdownButton>
                    </Form.Group>
                </div>
                
                <div className="mt-4">
                    <SearchListComponent 
                        placeholder="branch code or name"
                        label="Branch"
                        labelIcon={<Shop size={16} className="mb-1 me-1" />}
                        data={this.getBranchData()}
                        onClickBranch={this.handleOnSelectAdvancedSearchRestaurant}
                        activeListId={parseInt(this.props.poRestuarant)}
                    />
                </div>
            </Col>
            }
            <Col>
            {this.props.auth.mode === RESTAURANT &&
            <div>
                <Form.Group controlId="dropdown-filter-restaurant-button" className="mt-4 me-4 ms-3">
                    <Form.Label className="font-weight-bold"><Shop size={16} className="mb-1 me-1" /> <I18N type={UI} path="BRANCH" def="Branch"/></Form.Label>
                    <DropdownButton
                        className="mw-200"
                        id="dropdown-filter-restaurant-button"
                        title={this.getAdvancedSearchRestaurantTitle()}
                        onSelect={this.handleOnSelectAdvancedSearchRestaurant}
                    >
                        <Dropdown.Item as="button" eventKey=""><I18N type={UI} path="ALL_BRANCHES" def="All Branches"/></Dropdown.Item>
                        {this.htmlAdvancedSearchRestaurantOptions()}
                    </DropdownButton>
                </Form.Group>
            </div>
            }

            {mode === 2 && this.props.auth.mode !== SUPPLIER && this.props.auth.ui.purchaseOrders.approved.filterSupplier &&
            <div className="mt-4">
                <Form.Group controlId="dropdown-filter-supplier-type-button" className="ms-3">
                    <Form.Label className="font-weight-bold mb-0"><Basket size={16} className="me-1" /> <I18N type={UI} path="SUPPLIER" def="Supplier"/></Form.Label>
                    <div>
                        {this.state.isInternalSupplier &&
                        <DropdownButton
                        as={ButtonGroup}
                        id="dropdown-filter-supplier-type-button"
                        title={this.getAdvancedSearchSupplierInternalTitle()}
                        onSelect={this.handleOnSelectAdvancedSearchInternal}
                        className="mt-2 me-4 mw-200"
                        >
                        <Dropdown.Item as="button" eventKey={JSON.stringify({supplierId:"all", supplierName:"All Internal Suppliers"})}><I18N type={UI} path="ALL_INTERNAL_SUPPLIERS" def="All Internal Suppliers"/></Dropdown.Item>
                        {this.htmlAdvancedSearchInternalSupplierOptions()}
                        </DropdownButton>
                        }

                        <DropdownButton
                        as={ButtonGroup}
                        id="dropdown-filter-supplier-type-button"
                        title={this.getAdvancedSearchSupplierExternalTitle()}
                        onSelect={this.handleOnSelectAdvancedSearchExternal}
                        className="mt-2 mw-200"
                        >
                        <Dropdown.Item as="button" eventKey={JSON.stringify({supplierId:"all", supplierName:"All External Suppliers"})}><I18N type={UI} path="ALL_EXTERNAL_SUPPLIERS" def="All External Suppliers"/></Dropdown.Item>
                        {this.htmlAdvancedSearchExternalSupplierOptions()}
                        </DropdownButton>
                       
                    </div>
                </Form.Group>

                {/*
                <Form.Check
                    id="po-type-supplier-internal"
                    type="checkbox" 
                    label="Internal Supplier"
                    checked={this.getSupplierTypeChecked() === "internal"}
                    onChange={() => {
                        this.handleOnChangePOSupplierType();
                    }}
                />*/}



                {/*(this.props.poSupplierType === INTERNAL || this.props.auth.mode === SUPPLIER) && this.props.auth.ui.purchaseOrders.approved.selectTodays &&
                <>
                    <div className="mt-4">
                        <span className="font-weight-bold"><Check2 size={16} className="me-1" />Select Today's</span>
                    </div>
                    <div className="mt-2">
                        
                        <Form.Check 
                            inline
                            id="select-todays-radio-purchase-orders"
                            type="radio" 
                            name="select-todays-radio"
                            label={"Purchase Orders"}
                            checked={this.props.selectTodays === 'purchases' ? true : false}
                            onChange={() => {
                                this.handleOnChangeSelectTodays('purchases');
                            }}
                        />
                        
                        {this.props.auth.ui.purchaseOrders.approved.weighing &&
                        <Form.Check 
                            inline
                            id="select-todays-radio-pending-weight"
                            type="radio" 
                            name="select-todays-radio"
                            label={"Pending Weight"}
                            checked={this.props.selectTodays === 'weighing' ? true : false}
                            onChange={() => {
                                this.handleOnChangeSelectTodays('weighing');
                            }}
                        />
                        }
                        
                        <Form.Check 
                            inline
                            id="select-todays-radio-uncheck"
                            type="radio" 
                            name="select-todays-radio"
                            label={"None"}
                            checked={this.props.selectTodays === 'uncheck' ? true : false}
                            onChange={() => {
                                this.handleOnChangeSelectTodays('uncheck');
                            }}
                        />

                    </div>
                </>
                */}

                {/*
                <Form.Check
                    inline 
                    id="po-type-supplier-external"
                    type="checkbox" 
                    label="External"
                    checked={this.getSupplierTypeChecked() === "external"}
                    onChange={() => {
                        this.handleOnChangePOSupplierType("external");
                    }}
                />
                */}
            </div>
            }

            {/*this.props.auth.ui.purchaseOrders.approved.interval &&
            <>
            <div className="mt-4">
                <div className="d-inline-block align-top">
                    <span className="font-weight-bold"><Calendar size={16} className="mb-1 me-1" /> Date</span>
                    <div className="mt-2">
                        <SingleDatePicker
                            date={this.state.singleDate} // momentPropTypes.momentObj or null
                            onDateChange={date => this.setState({
                                singleDate:date
                            })} // PropTypes.func.isRequired
                            focused={this.state.focused}
                            onFocusChange={({ focused }) => {
                                this.setState({
                                    focused:focused
                                })
                            }}
                            id="singledatepicker" // PropTypes.string.isRequired,
                            displayFormat={() => "DD/MM/YYYY"}
                            isOutsideRange={() => false}
                        />
                    </div>
                </div>
                <div className="d-inline-block ms-4 align-top">
                    <span className="font-weight-bold"><Calendar size={16} className="mb-1 me-1" /> Interval</span>
                    <DropdownButton
                        id="filter-interval"
                        title={this.getIntervalTitle()}
                        onSelect={this.handleOnSelectInterval}
                        className="mt-2"
                    >
                        <Dropdown.Item as="button" eventKey="">Select Interval</Dropdown.Item>
                        {this.htmlIntervalOptions()}
                    </DropdownButton>
                </div>
            </div>
            
            {data.length && this.state.interval
            ?
            <div className="mt-4">
                <div className="mt-4">
                    <span className="font-weight-bold"><Calendar size={16} className="me-1" /> Purchase Orders</span>
                </div>
                <div className="mt-2">

                    <Form.Check 
                        inline
                        id="purchase-orders-radio-all"
                        type="radio" 
                        name="select-todays-radio"
                        label={"Check"}
                        checked={this.props.selectTodays === 'all' ? true : false}
                        onChange={() => {
                            this.handleOnChangeSelectTodays('all');
                        }}
                    />
                    
                    <Form.Check 
                        inline
                        id="purchase-orders-radio-uncheck"
                        type="radio" 
                        name="select-todays-radio"
                        label={"Uncheck"}
                        checked={this.props.selectTodays === 'uncheck' ? true : false}
                        onChange={() => {
                            this.handleOnChangeSelectTodays('uncheck');
                        }}
                    />
                </div>
            </div>
            :
            <></>
            }

            </>
            */}
            </Col>
        </Row>
        <Row  className="bg-light rounded-bottom">
            <Col md="auto" className="ms-3 mb-4">
                <Form className="d-sm-flex" onSubmit={(e) => e.preventDefault()}>
                    
                    {( (!this.props.auth.consolidation && mode === 1) || mode !== 1 ) && 
                    <Form.Group controlId="search-po-number" className="mt-4 me-4">
                        <Form.Label className="font-weight-bold"><Search size={16} className="mb-1 me-1" /> <I18N type={UI} path="FILTER" def="Filter"/></Form.Label>
                            <InputGroup>
                                <Form.Control 
                                    type="textbox" 
                                    name="search" 
                                    placeholder={this.state.i18n["ENTER_PURCHASE_ORDER_NUMBER"]}
                                    onChange={(e) => this.handleSearchPOChange(e.currentTarget.value)}
                                    //onBlur={handleBlur}
                                    value={this.getSearchPOString()}
                                />
                                {this.getSearchPOString() &&
                                <InputGroup.Text 
                                    className="is-hover" 
                                    onClick={ () => this.props.setPOFilterFields({
                                        field:"searchPO",
                                        value:""
                                    }).then(() => {
                                        this.props.setPOApprovedPagination(1)
                                        .then( () => {
                                            this.getErpIsPush()
                                        });   
                                    })}
                                >
                                    Clear
                                </InputGroup.Text>
                                }
                            </InputGroup>
                    </Form.Group>
                    }

                    {mode === 2 &&
                    <>
                    <Form.Group controlId="dropdown-filter-operator-button" className="mt-4 me-4">
                            <Form.Label className="font-weight-bold"><Person size={16} className="mb-1 me-1" /> <I18N type={UI} path="OPERATOR" def="Operator"/></Form.Label>
                            <DropdownButton
                            className="d-grid mw-200"
                            id="dropdown-filter-operator-button"
                            title={this.getSearchOperatorTitle()}
                            onSelect={this.handleOnSelectOperator}
                        >
                            <Dropdown.Item as="button" eventKey=""><I18N type={UI} path="ALL_OPERATORS" def="All Operators"/></Dropdown.Item>
                            {this.htmlSearchOperatorOptions()}
                        </DropdownButton>
                    </Form.Group>
                    {this.props.auth.ui.purchaseOrders.approved.weighing &&
                    <div className="mt-4 me-4">
                        <Form.Check
                            id="select-todays-weighing-checkbox"
                            type="checkbox"
                            label={<I18N type={UI} path="PENDING_WEIGHING" def="Pending Weighing"/>}
                            checked={this.props.poFilterFields.weighing ? true : false}
                            onChange={(e) => {
                                this.handleFilterWeighing(e.currentTarget.checked)
                            }}
                            style={{marginTop:'2.25rem'}}
                        />
                    </div>
                    }
                    </>
                    }
                </Form>
            </Col>
            <Col className="text-lg-end me-3 mb-4">
            {(mode === 2) &&
                <Form.Group controlId="btn-search-date" className="mt-4">
                    <span className="font-weight-bold"><Calendar4 size={16} className="mb-1 me-1" /> <I18N type={UI} path="DATE" def="Date"/></span>
                    <div className="mt-2">
                        <Button 
                            id="btn-search-date"
                            variant="secondary" 
                            className="me-3 mw-110 text-left"
                            onClick={ () => this.handleToggleDate(this.props.poSearchFields.searchDateType)}>
                            {this.props.poSearchFields.searchDateType === CREATE
                            ?
                                <>
                                <ToggleOff size={20} className="mb-1 me-1" />
                                <span><I18N type={UI} path="CREATE" def="Create"/></span>
                                </>
                            :
                                <>
                                <ToggleOn size={20} className="mb-1 me-1" />
                                <span><I18N type={UI} path="DELIVERY" def="Delivery"/></span>
                                </>
                            }
                        </Button>

                        {mode === 2 &&
                            <SingleDatePicker
                            date={moment(this.props.poSearchFields.searchDate)} // momentPropTypes.momentObj or null
                            onDateChange={date => this.handleSearchDateChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused2}
                            onFocusChange={({ focused }) => {
                                this.setState({
                                    focused2:focused
                                })
                            }}
                            id="singledatepicker2" // PropTypes.string.isRequired,
                            orientation={orientation}
                            displayFormat={() => "DD/MM/YYYY"}
                            isOutsideRange={() => false}
                            
                            isDayHighlighted={(day) => {
                                if(highlightedDays.indexOf(moment(day).format('YYYY-MM-DD')) > -1) {
                                    return true;
                                }
                                return false;
                            }}
                            />
                        }
                        {mode === 4 &&
                            <SingleDatePicker
                            date={this.props.poSearchFields.searchDate} // momentPropTypes.momentObj or null
                            onDateChange={date => this.handleSearchDateChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused4}
                            onFocusChange={({ focused }) => {
                                this.setState({
                                    focused4:focused
                                })
                            }}
                            id="singledatepicker4" // PropTypes.string.isRequired,
                            orientation={orientation}
                            displayFormat={() => "DD/MM/YYYY"}
                            isOutsideRange={() => false}
                            
                            />
                        }
                        
                        {/*
                        <Form.Check 
                            inline
                            id="search-date-create-radio"
                            type="radio" 
                            name="search-date-radio"
                            label={"Create Date"}
                            checked={this.state.searchDate === "create" ? true : false}
                            onChange={(e) => {
                                this.setState({
                                    searchDate:'create'
                                });
                            }}
                        />
                        <Form.Check 
                            inline
                            id="search-date-delivery-radio"
                            type="radio" 
                            name="search-date-radio"
                            label={"Delivery Date"}
                            checked={this.state.searchDate === "delivery" ? true : false}
                            onChange={() => {
                                this.setState({
                                    searchDate:'delivery'
                                });
                            }}
                        />
                        */}
                    </div>
                </Form.Group>
                }
            </Col>
        </Row>
        <Row className="mt-2">
            <Col>
                { 
                    data.length === 0 && <Alert className="bg-info text-white"><ExclamationCircle size={16} className="mb-1 me-1" /><I18N type={UI} path="NO_RESULTS" def="No Results"/></Alert>
                }

                    {mode === 2 && this.state.alertErrorMessage && <AlertErrorComponent label={this.state.alertErrorMessage} />}

                    {mode === 1
                    ?
                    <div className="overflow-scroll">
                    <Table bordered hover size="sm" responsive className="text-xs-nowrap">
                        <thead>
                        <tr>
                            {!this.props.auth.consolidation && <th><CardList size={16} className="mb-1 me-1" /> <I18N type={UI} path="ORDER_NUMBER" def="訂單"/></th>}
                            <th><Shop size={16} className="mb-1 me-1" /> <I18N type={UI} path="BRANCH" def="餐廳"/></th>
                            {this.props.auth.consolidation && <th><Calendar4 size={16} className="mb-1 me-1" /> 要求送貨日期</th>}
                            {!this.props.auth.consolidation && <th><PersonBoundingBox size={16} className="mb-1 me-1" /> <I18N type={UI} path="DEPARTMENT" def="部門"/></th>}
                            {this.props.auth.mode === RESTAURANT && <th><Basket size={16} className="mb-1 me-1" /> <I18N type={UI} path="SUPPLIER" def="供應商"/></th>}
                        </tr>
                        </thead>
                        <tbody>
                            {this.htmlPOTableRows(1, data)}
                        </tbody>
                    </Table>   
                    </div>                 
                    :
                    <div className="overflow-scroll">
                    <Table bordered hover size="sm" responsive className="text-xs-nowrap">
                        <thead>
                            <tr>
                                {mode === 2 && 
                                (this.props.poSupplierType === INTERNAL || this.props.auth.mode === SUPPLIER) &&
                                <th className="text-center">
                                    <ButtonGroup>
                                      
                                        <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                        <Tooltip id={`button-tooltip-check-po`}>
                                            {this.props.selectTodays === "purchases" ? <I18N type={UI} path="UNCHECK_PURCHASES" def="Uncheck Purchases"/> : <I18N type={UI} path="CHECK_PURCHASES" def="Check Purchases"/>}
                                        </Tooltip>}
                                        >
                                        <ToggleButton
                                            key={0}
                                            id={`checkbox-check-po`}
                                            type="checkbox"
                                            variant=""
                                            name="checkbox"
                                            checked={this.props.selectTodays === "purchases" ? true: false}
                                            value={true}
                                            onChange={(e) => this.handleOnChangeSelectTodays(e.currentTarget.checked)}
                                            style={{borderRadius: '6px',margin:'4px'}}
                                        >
                                            {this.props.selectTodays === "purchases"
                                                ? 
                                                <CheckSquare size={16} />
                                                :
                                                <Square size={16} />
                                            }
                                        </ToggleButton>
                                        </OverlayTrigger>
                                    </ButtonGroup>
                                </th>}
                                <th><CardList size={16} className="mb-1 me-1" /> <I18N type={UI} path="ORDER_NUMBER" def="訂單號碼"/></th>
                                <th><Calendar4 size={16} className="mb-1 me-1" /> <I18N type={UI} path="ORDER_NUMBER" def="訂購日期"/></th>
                                <th><Calendar4 size={16} className="mb-1 me-1" /> <I18N type={UI} path="ORDER_DATE" def="送貨日期"/></th>
                                <th><Shop size={16} className="mb-1 me-1" /> <I18N type={UI} path="BRANCH" def="餐廳"/></th>
                                {console.log("AUTH PROPS: ", this.props.auth.consolidation)}
                                {!this.props.auth.consolidation && <th><PersonBoundingBox size={16} className="mb-1 me-1" /> <I18N type={UI} path="BRANCH" def="部門"/></th>}
                                {this.props.auth.mode === RESTAURANT &&<th><Basket size={16} className="mb-1 me-1" /> <I18N type={UI} path="SUPPLIER" def="供應商"/></th>}
                                {mode === 2 && this.props.auth.ui.purchaseOrders.approved.weighing && <th><BoxSeam size={16} className="mb-1 me-1" /> <I18N type={UI} path="AWAITING_ACTION" def="等待抄碼"/></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.isPOSearch
                                ?
                                <tr>
                                    <td colSpan="10" className="text-center p-4">
                                        <Spinner 
                                            animation="border" 
                                            role="status"
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </td>
                                </tr>
                                :
                                this.htmlPOTableRows(mode, data)
                            }
                        </tbody>
                    </Table>
                    </div>
                    }
               
            
                {paginationIntervals > 1 &&
                    <PaginationComponent 
                        active={this.props.poApprovedPagination} 
                        length={paginationLength} 
                        intervals={paginationIntervals} 
                        handleClickPaginationItem={this.handleClickPaginationItem} 
                    />
                }
            </Col>
        </Row>
        </>
        );
    }

/*
Send to ERP
*/

    isDisabledButtonERP = () => {
        if(this.props.poApprovedChecked.length) {
            let disable = false;

            // check if any POs have outstanding weigh, if have return true
            let data = JSON.parse(JSON.stringify(this.state.dataPO));
            let filter = data.filter( (obj) => this.props.poApprovedChecked.indexOf(obj.POId) > -1 );
            filter.forEach( (obj) => {
                if(obj.isWeigh > 0 && obj.UnsetWeightCount > 0) {
                    disable = true;        
                }
            });

            return disable;
        }
        return true;
    }

    handleOpenModalERP = () => {
        this.setState({
            isVisibleModalERP:true
        }, () => {
            this.getPOHistoryList();
        });
    }

    handleCloseModalERP = () => {
        this.setState({
            isVisibleModalERP:false
        });  
    }

/*
On Success ERP
*/

    onSuccessSearchERP = (data) => {
        this.setState({
            poErpIsPush:data.data.data.values,
            isLoading:false,
            isPOSearch:false
        });
    }

/*
Handle Error ERP
*/

    onErrorSearchERP = () => {
        this.setState({
            isLoading:false,
            poErpIsPush:[]
        })
    }

/*
Is Loading
*/

    isLoading = () => {
        if( !this.state.dataPO || 
            this.state.isLoading ||
            !this.state.dataPODates ||
            (this.props.auth.erp.platform === MULTIABLE && !this.state.poErpIsPush)) {
            return true;
        }
        return false;
    }

/*
Set i18n
*/

    seti18n = async () => {

        let promises = [];

        [{
            type:'ui',
            path:'ENTER_PURCHASE_ORDER_NUMBER',
            def:'Enter Purchase Order Number'
        },{
            type:'ui',
            path:'CONFIRM_DATEPICKER_DATE',
            def:'Do you want to set the datepicker date to today?'
        }].forEach( (obj) => {
            promises.push(new Promise(resolve => {
                i18n(obj.type,obj.path,obj.def).then((value) => {
                    let i18n = JSON.parse(JSON.stringify(this.state.i18n));
                    if(value) {
                        i18n[obj.path] = value;
                    } else {
                        i18n[obj.path] = obj.def;
                    }     
                    this.setState({
                        i18n:i18n
                    }, () => {
                        resolve(obj);
                    });
                });
            }));   
        });

        return promises;
    }

/*
Render
*/

    render() {
        return (
            <>
            <Container fluid className="p-0">
                <NavbarComponent />
                <Container>
                    <Row>
                        <Col>
                            <div className="mt-4">
                                <h1><I18N type={UI} path="PURCHASE_ORDERS" def="Purchase Orders"/></h1>
                            </div>
                            

                            {this.state.authError
                            ?
                                <AuthErrorComponent />
                            :
                            
                                (this.state.serverError)
                                
                                ?
                                    <ServerErrorComponent />
                                :

                                   this.isLoading()
                                    ?
                                        <LoadingComponent />
                                    :
                                    <>
      

                                    <Tabs 
                                    //defaultActiveKey={!this.props.poType ? 1 : this.props.poType} 
                                    activeKey={!this.props.poType ? 1 : this.props.poType}
                                    id="approval-tab" 
                                    className="mt-4" 
                                    onSelect={ (value) => this.handleSelectTab(value)}
                                    >
                                        <Tab eventKey={1} title={<I18N type={UI} path="PENDING_APPROVAL" def="Pending Approval"/>} disabled={!this.props.auth.poApproval ? true : false}>
                                            <div className="mb-4">
                                                {/*<h2>Pending Approval</h2>*/}
                                                {this.htmlPOTab(1)}
                                            </div>
                                        </Tab>
                                        <Tab eventKey={2} title={<I18N type={UI} path="APPROVED" def="Approved"/>}>
                                            <div className="mb-4">
                                                {/*<h2>Approved</h2>*/}
                                                {this.htmlPOTab(2)}
                                            </div>
                                        </Tab>
                                        <Tab eventKey={4} title={<I18N type={UI} path="REJECTED" def="Rejected"/>}>
                                            <div className="mb-4">
                                                {/*<h2>Rejected</h2>*/}
                                                {this.htmlPOTab(4)}
                                            </div>
                                        </Tab>
                                    </Tabs>                            
                                </>
                            }

                        </Col>
                    </Row>
                </Container>
            </Container>
            <FooterComponent />
            {this.props.auth.erp && this.props.auth.erp.pushDate &&
            <PurchaseOrderERPComponent
                visible={this.state.isVisibleModalERP}
                data={JSON.parse(JSON.stringify(this.state.dataPO))}
                handleClose={() => this.handleCloseModalERP()}
            />
            }

            {this.props.auth.erp && 
            this.props.auth.erp.platform === MULTIABLE &&
            this.state.dataPO.length > 0 &&
            <PurchaseOrderERPComponent
                mode="search"
                params={{
                    stSearch: 'siso',
                    resultFields: 'udfhorussono',
                    conds:this.getPOERPSearchConditions(this.getPOData())
                }}
                onSuccess={(data) => this.onSuccessSearchERP(data)}
                onError={() => this.onErrorSearchERP()}
                key={this.state.key}
            />
            }

            </>
        )
    }

}

const mapStateToProps = state => {
    const {
        auth,
        poType,
        poApprovedChecked,
        selectTodays,
        selectAllTodayPO,
        selectIncompleteWeighingPO,
        poSupplierType,
        poSupplier,
        poRestuarant,
        poFilterFields,
        poSearchFields,
        poApprovedPagination
    } = state;

    return {
        auth: auth,
        poType: poType,
        poApprovedChecked: poApprovedChecked,
        selectTodays: selectTodays,
        selectAllTodayPO: selectAllTodayPO,
        selectIncompleteWeighingPO: selectIncompleteWeighingPO,
        poSupplierType: poSupplierType,
        poSupplier: poSupplier,
        poRestuarant: poRestuarant,
        poFilterFields: poFilterFields,
        poSearchFields: poSearchFields,
        poApprovedPagination: poApprovedPagination
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderRestaurant));
